// Curated US large-cap universe grouped by sector.
// weight ≈ approximate market cap in $B (used for treemap cell sizing).

export const STOCK_UNIVERSE = [
  // ── Technology ─────────────────────────────────────────────
  { ticker: 'AAPL',  name: 'Apple',              sector: 'Technology', weight: 3400 },
  { ticker: 'MSFT',  name: 'Microsoft',          sector: 'Technology', weight: 3200 },
  { ticker: 'NVDA',  name: 'NVIDIA',             sector: 'Technology', weight: 2900 },
  { ticker: 'AVGO',  name: 'Broadcom',           sector: 'Technology', weight: 800  },
  { ticker: 'ORCL',  name: 'Oracle',             sector: 'Technology', weight: 550  },
  { ticker: 'CRM',   name: 'Salesforce',         sector: 'Technology', weight: 280  },
  { ticker: 'CSCO',  name: 'Cisco',              sector: 'Technology', weight: 230  },
  { ticker: 'AMD',   name: 'AMD',                sector: 'Technology', weight: 250  },
  { ticker: 'ADBE',  name: 'Adobe',              sector: 'Technology', weight: 220  },
  { ticker: 'ACN',   name: 'Accenture',          sector: 'Technology', weight: 200  },
  { ticker: 'TXN',   name: 'Texas Instruments',  sector: 'Technology', weight: 180  },
  { ticker: 'IBM',   name: 'IBM',                sector: 'Technology', weight: 170  },
  { ticker: 'QCOM',  name: 'Qualcomm',           sector: 'Technology', weight: 160  },
  { ticker: 'INTU',  name: 'Intuit',             sector: 'Technology', weight: 175  },
  { ticker: 'AMAT',  name: 'Applied Materials',  sector: 'Technology', weight: 145  },
  { ticker: 'INTC',  name: 'Intel',              sector: 'Technology', weight: 150  },
  { ticker: 'MU',    name: 'Micron',             sector: 'Technology', weight: 110  },
  { ticker: 'PANW',  name: 'Palo Alto Networks', sector: 'Technology', weight: 130  },

  // ── Communication Services ─────────────────────────────────
  { ticker: 'GOOGL', name: 'Alphabet',           sector: 'Communication', weight: 2100 },
  { ticker: 'META',  name: 'Meta Platforms',     sector: 'Communication', weight: 1600 },
  { ticker: 'NFLX',  name: 'Netflix',            sector: 'Communication', weight: 300  },
  { ticker: 'DIS',   name: 'Disney',             sector: 'Communication', weight: 190  },
  { ticker: 'CMCSA', name: 'Comcast',            sector: 'Communication', weight: 165  },
  { ticker: 'VZ',    name: 'Verizon',            sector: 'Communication', weight: 180  },
  { ticker: 'T',     name: 'AT&T',               sector: 'Communication', weight: 160  },
  { ticker: 'TMUS',  name: 'T-Mobile',           sector: 'Communication', weight: 240  },

  // ── Consumer Discretionary ─────────────────────────────────
  { ticker: 'AMZN',  name: 'Amazon',             sector: 'Consumer Disc.', weight: 2000 },
  { ticker: 'TSLA',  name: 'Tesla',              sector: 'Consumer Disc.', weight: 1100 },
  { ticker: 'HD',    name: 'Home Depot',         sector: 'Consumer Disc.', weight: 400  },
  { ticker: 'MCD',   name: 'McDonalds',          sector: 'Consumer Disc.', weight: 210  },
  { ticker: 'NKE',   name: 'Nike',               sector: 'Consumer Disc.', weight: 130  },
  { ticker: 'LOW',   name: 'Lowes',              sector: 'Consumer Disc.', weight: 140  },
  { ticker: 'SBUX',  name: 'Starbucks',          sector: 'Consumer Disc.', weight: 110  },
  { ticker: 'TJX',   name: 'TJX Companies',      sector: 'Consumer Disc.', weight: 135  },
  { ticker: 'BKNG',  name: 'Booking',            sector: 'Consumer Disc.', weight: 165  },

  // ── Consumer Staples ───────────────────────────────────────
  { ticker: 'WMT',   name: 'Walmart',            sector: 'Consumer Staples', weight: 650 },
  { ticker: 'COST',  name: 'Costco',             sector: 'Consumer Staples', weight: 420 },
  { ticker: 'PG',    name: 'Procter & Gamble',   sector: 'Consumer Staples', weight: 380 },
  { ticker: 'KO',    name: 'Coca-Cola',          sector: 'Consumer Staples', weight: 280 },
  { ticker: 'PEP',   name: 'PepsiCo',            sector: 'Consumer Staples', weight: 220 },
  { ticker: 'PM',    name: 'Philip Morris',      sector: 'Consumer Staples', weight: 200 },
  { ticker: 'MDLZ',  name: 'Mondelez',           sector: 'Consumer Staples', weight: 90  },

  // ── Financials ─────────────────────────────────────────────
  { ticker: 'BRK-B', name: 'Berkshire Hathaway', sector: 'Financials', weight: 1000 },
  { ticker: 'JPM',   name: 'JPMorgan Chase',     sector: 'Financials', weight: 950  },
  { ticker: 'V',     name: 'Visa',               sector: 'Financials', weight: 800  },
  { ticker: 'MA',    name: 'Mastercard',         sector: 'Financials', weight: 450  },
  { ticker: 'BAC',   name: 'Bank of America',    sector: 'Financials', weight: 320  },
  { ticker: 'WFC',   name: 'Wells Fargo',        sector: 'Financials', weight: 210  },
  { ticker: 'GS',    name: 'Goldman Sachs',      sector: 'Financials', weight: 175  },
  { ticker: 'MS',    name: 'Morgan Stanley',     sector: 'Financials', weight: 180  },
  { ticker: 'AXP',   name: 'American Express',   sector: 'Financials', weight: 200  },
  { ticker: 'BLK',   name: 'BlackRock',          sector: 'Financials', weight: 145  },
  { ticker: 'C',     name: 'Citigroup',          sector: 'Financials', weight: 130  },
  { ticker: 'SCHW',  name: 'Charles Schwab',     sector: 'Financials', weight: 145  },

  // ── Healthcare ─────────────────────────────────────────────
  { ticker: 'LLY',   name: 'Eli Lilly',          sector: 'Healthcare', weight: 850 },
  { ticker: 'UNH',   name: 'UnitedHealth',       sector: 'Healthcare', weight: 480 },
  { ticker: 'JNJ',   name: 'Johnson & Johnson',  sector: 'Healthcare', weight: 380 },
  { ticker: 'ABBV',  name: 'AbbVie',             sector: 'Healthcare', weight: 320 },
  { ticker: 'MRK',   name: 'Merck',              sector: 'Healthcare', weight: 250 },
  { ticker: 'TMO',   name: 'Thermo Fisher',      sector: 'Healthcare', weight: 200 },
  { ticker: 'ABT',   name: 'Abbott',             sector: 'Healthcare', weight: 200 },
  { ticker: 'DHR',   name: 'Danaher',            sector: 'Healthcare', weight: 170 },
  { ticker: 'PFE',   name: 'Pfizer',             sector: 'Healthcare', weight: 160 },
  { ticker: 'AMGN',  name: 'Amgen',              sector: 'Healthcare', weight: 160 },
  { ticker: 'CVS',   name: 'CVS Health',         sector: 'Healthcare', weight: 80  },

  // ── Energy ─────────────────────────────────────────────────
  { ticker: 'XOM',   name: 'ExxonMobil',         sector: 'Energy', weight: 480 },
  { ticker: 'CVX',   name: 'Chevron',            sector: 'Energy', weight: 280 },
  { ticker: 'COP',   name: 'ConocoPhillips',     sector: 'Energy', weight: 140 },
  { ticker: 'SLB',   name: 'Schlumberger',       sector: 'Energy', weight: 60  },
  { ticker: 'EOG',   name: 'EOG Resources',      sector: 'Energy', weight: 70  },

  // ── Industrials ────────────────────────────────────────────
  { ticker: 'GE',    name: 'General Electric',   sector: 'Industrials', weight: 190 },
  { ticker: 'CAT',   name: 'Caterpillar',        sector: 'Industrials', weight: 180 },
  { ticker: 'RTX',   name: 'RTX Corp',           sector: 'Industrials', weight: 165 },
  { ticker: 'HON',   name: 'Honeywell',          sector: 'Industrials', weight: 140 },
  { ticker: 'UNP',   name: 'Union Pacific',      sector: 'Industrials', weight: 145 },
  { ticker: 'BA',    name: 'Boeing',             sector: 'Industrials', weight: 120 },
  { ticker: 'DE',    name: 'Deere',              sector: 'Industrials', weight: 115 },
  { ticker: 'UPS',   name: 'UPS',                sector: 'Industrials', weight: 110 },
  { ticker: 'LMT',   name: 'Lockheed Martin',    sector: 'Industrials', weight: 110 },

  // ── Utilities ──────────────────────────────────────────────
  { ticker: 'NEE',   name: 'NextEra Energy',     sector: 'Utilities', weight: 145 },
  { ticker: 'SO',    name: 'Southern Company',   sector: 'Utilities', weight: 95  },
  { ticker: 'DUK',   name: 'Duke Energy',        sector: 'Utilities', weight: 90  },

  // ── Real Estate ────────────────────────────────────────────
  { ticker: 'PLD',   name: 'Prologis',           sector: 'Real Estate', weight: 110 },
  { ticker: 'AMT',   name: 'American Tower',     sector: 'Real Estate', weight: 95  },
  { ticker: 'EQIX',  name: 'Equinix',            sector: 'Real Estate', weight: 80  },

  // ── Materials ──────────────────────────────────────────────
  { ticker: 'LIN',   name: 'Linde',              sector: 'Materials', weight: 220 },
  { ticker: 'SHW',   name: 'Sherwin-Williams',   sector: 'Materials', weight: 90  },
  { ticker: 'FCX',   name: 'Freeport-McMoRan',   sector: 'Materials', weight: 70  },
];

export const SECTORS = [
  'Technology',
  'Communication',
  'Consumer Disc.',
  'Consumer Staples',
  'Financials',
  'Healthcare',
  'Energy',
  'Industrials',
  'Utilities',
  'Real Estate',
  'Materials',
];

// Crypto universe (~50 tokens) grouped by category. Weights ≈ market cap in $B.
export const CRYPTO_UNIVERSE = [
  // ── Layer 1 ─────────────────────────────────────────────
  { ticker: 'BTC-USD',   name: 'Bitcoin',         category: 'Layer 1', weight: 1900 },
  { ticker: 'ETH-USD',   name: 'Ethereum',        category: 'Layer 1', weight: 400  },
  { ticker: 'BNB-USD',   name: 'BNB',             category: 'Layer 1', weight: 90   },
  { ticker: 'SOL-USD',   name: 'Solana',          category: 'Layer 1', weight: 85   },
  { ticker: 'TRX-USD',   name: 'Tron',            category: 'Layer 1', weight: 28   },
  { ticker: 'TON11419-USD', name: 'Toncoin',      category: 'Layer 1', weight: 25, displayTicker: 'TON' },
  { ticker: 'ADA-USD',   name: 'Cardano',         category: 'Layer 1', weight: 22   },
  { ticker: 'AVAX-USD',  name: 'Avalanche',       category: 'Layer 1', weight: 18   },
  { ticker: 'HBAR-USD',  name: 'Hedera',          category: 'Layer 1', weight: 14   },
  { ticker: 'DOT-USD',   name: 'Polkadot',        category: 'Layer 1', weight: 14   },
  { ticker: 'NEAR-USD',  name: 'NEAR Protocol',   category: 'Layer 1', weight: 12   },
  { ticker: 'ICP-USD',   name: 'Internet Computer', category: 'Layer 1', weight: 10 },
  { ticker: 'SUI20947-USD', name: 'Sui',          category: 'Layer 1', weight: 9, displayTicker: 'SUI' },
  { ticker: 'APT21794-USD', name: 'Aptos',        category: 'Layer 1', weight: 7, displayTicker: 'APT' },
  { ticker: 'ATOM-USD',  name: 'Cosmos',          category: 'Layer 1', weight: 6    },
  { ticker: 'ALGO-USD',  name: 'Algorand',        category: 'Layer 1', weight: 5    },
  { ticker: 'XTZ-USD',   name: 'Tezos',           category: 'Layer 1', weight: 3    },
  { ticker: 'EGLD-USD',  name: 'MultiversX',      category: 'Layer 1', weight: 3    },

  // ── Layer 2 ─────────────────────────────────────────────
  { ticker: 'MATIC-USD', name: 'Polygon',         category: 'Layer 2', weight: 18 },
  { ticker: 'ARB-USD',   name: 'Arbitrum',        category: 'Layer 2', weight: 8  },
  { ticker: 'OP-USD',    name: 'Optimism',        category: 'Layer 2', weight: 6  },
  { ticker: 'IMX-USD',   name: 'Immutable',       category: 'Layer 2', weight: 4  },
  { ticker: 'STX4847-USD', name: 'Stacks',        category: 'Layer 2', weight: 5, displayTicker: 'STX' },

  // ── DeFi ────────────────────────────────────────────────
  { ticker: 'LINK-USD',  name: 'Chainlink',       category: 'DeFi', weight: 25 },
  { ticker: 'UNI-USD',   name: 'Uniswap',         category: 'DeFi', weight: 15 },
  { ticker: 'LDO-USD',   name: 'Lido DAO',        category: 'DeFi', weight: 10 },
  { ticker: 'AAVE-USD',  name: 'Aave',            category: 'DeFi', weight: 8  },
  { ticker: 'INJ-USD',   name: 'Injective',       category: 'DeFi', weight: 6  },
  { ticker: 'COMP-USD',  name: 'Compound',        category: 'DeFi', weight: 4  },
  { ticker: 'CRV-USD',   name: 'Curve DAO',       category: 'DeFi', weight: 3  },
  { ticker: 'SNX-USD',   name: 'Synthetix',       category: 'DeFi', weight: 2  },

  // ── Payments ────────────────────────────────────────────
  { ticker: 'XRP-USD',   name: 'XRP',             category: 'Payments', weight: 80 },
  { ticker: 'XLM-USD',   name: 'Stellar',         category: 'Payments', weight: 18 },
  { ticker: 'LTC-USD',   name: 'Litecoin',        category: 'Payments', weight: 9  },
  { ticker: 'BCH-USD',   name: 'Bitcoin Cash',    category: 'Payments', weight: 8  },
  { ticker: 'FIL-USD',   name: 'Filecoin',        category: 'Payments', weight: 5  },

  // ── Memecoins ───────────────────────────────────────────
  { ticker: 'DOGE-USD',  name: 'Dogecoin',        category: 'Memecoins', weight: 45 },
  { ticker: 'SHIB-USD',  name: 'Shiba Inu',       category: 'Memecoins', weight: 18 },
  { ticker: 'PEPE24478-USD', name: 'Pepe',        category: 'Memecoins', weight: 10, displayTicker: 'PEPE' },
  { ticker: 'WIF-USD',   name: 'Dogwifhat',       category: 'Memecoins', weight: 5  },
  { ticker: 'BONK-USD',  name: 'Bonk',            category: 'Memecoins', weight: 4  },
  { ticker: 'FLOKI-USD', name: 'Floki',           category: 'Memecoins', weight: 3  },

  // ── Gaming / Metaverse ──────────────────────────────────
  { ticker: 'SAND-USD',  name: 'The Sandbox',     category: 'Gaming', weight: 3 },
  { ticker: 'MANA-USD',  name: 'Decentraland',    category: 'Gaming', weight: 2 },
  { ticker: 'AXS-USD',   name: 'Axie Infinity',   category: 'Gaming', weight: 2 },
  { ticker: 'CHZ-USD',   name: 'Chiliz',          category: 'Gaming', weight: 2 },
  { ticker: 'FLOW-USD',  name: 'Flow',            category: 'Gaming', weight: 2 },
  { ticker: 'THETA-USD', name: 'Theta Network',   category: 'Gaming', weight: 2 },
];

export const CRYPTO_CATEGORIES = [
  'Layer 1',
  'Layer 2',
  'DeFi',
  'Payments',
  'Memecoins',
  'Gaming',
];
